<div id="main-container">
  @if (this.nativeService.isDesktop()) {
    <slotcom-warning-landscape></slotcom-warning-landscape>
    <slotcom-cookie-consent></slotcom-cookie-consent>
  }

  @if (loaded()) {
    <router-outlet></router-outlet>
  } @else {
    <slotcom-pre-loader></slotcom-pre-loader>
  }
  <slotcom-payment-provider-settings></slotcom-payment-provider-settings>

  @if (user.isTester) {
    <div class="c-tester">
      <span
        class="icons-sprite tiny star-shadow"
        data-testid="slotcom-testerPanel-button"
        (click)="openTesterPanel()"></span>
    </div>
  }

  @if (eventManager.isNavigating$ | async) {
    <div class="navigating-overlay">
      <slotcom-loading
        class="centered"
        [color]="'blue'"></slotcom-loading>
    </div>
  }
</div>
